import { render, staticRenderFns } from "./CMAddContactGroup.vue?vue&type=template&id=437b917e&"
import script from "./CMAddContactGroup.vue?vue&type=script&lang=js&"
export * from "./CMAddContactGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('437b917e')) {
      api.createRecord('437b917e', component.options)
    } else {
      api.reload('437b917e', component.options)
    }
    module.hot.accept("./CMAddContactGroup.vue?vue&type=template&id=437b917e&", function () {
      api.rerender('437b917e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/contacts/CMAddContactGroup.vue"
export default component.exports